import { render, staticRenderFns } from "./ModelPartForm.vue?vue&type=template&id=3a5596af&"
import script from "./ModelPartForm.vue?vue&type=script&lang=js&"
export * from "./ModelPartForm.vue?vue&type=script&lang=js&"
import style0 from "./ModelPartForm.vue?vue&type=style&index=0&id=3a5596af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports